import {
  CertificationEventCode,
  DutyEventCode,
  EngineEventCode,
  IntermediateEventCode,
  LogEventType,
  LogRecordStatus,
  LoginEventCode,
  PersonalUseEventCode,
} from '@fleet-beat/core';
import { RecordStatus } from '../../enums';

export interface AddInfoLogModel {
  truckId?: string;
  eventType?: LogEventType;
  eventCode?:
    | PersonalUseEventCode
    | DutyEventCode
    | CertificationEventCode
    | LoginEventCode
    | EngineEventCode
    | IntermediateEventCode;
  startedAt?: string;
  endedAt?: string;
  status?: `${LogRecordStatus}`;
  notes?: string;
  odometer?: number;
  normalizedOdometer?: number;
  engineHours?: number;
  lat?: number;
  lon?: number;
  address?: string;
  trailerNumber?: string;
  isLocked?: boolean;
  certifyDate?: string;
  driverSignatureUrl?: string;
  shippingDocument?: string;
  recordStatus?: RecordStatus;
}
